exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-results[data-v-561e7660]{position:absolute;background:#fff;width:100%;z-index:10;border:1px solid #ccc;border-top:none;max-height:200px;overflow-y:auto;padding:.8rem 1rem}.autocomplete-item[data-v-561e7660]{padding:8px;cursor:pointer}.autocomplete-active[data-v-561e7660],.autocomplete-item[data-v-561e7660]:hover{background:#eee}.emptymessage[data-v-561e7660]{padding:8px;color:#999}", ""]);

// exports
